import {camelize, checkLocalStorage, kvps, setLocalStorage} from 'src/utilities/utils'
import {ptracGetEntities} from 'src/utilities/ptracApi'
import {make} from 'vuex-pathify'
import {resetState} from 'src/utilities/vuex2'
import {OK} from 'http-status-codes'
import Constants from '@/utilities/constants'

const state = {
  ptracTask: [],
  taskTemplate: [],
  field: [],
  job: [],
  company: []
}

const getters = make.getters(state)
const mutations = make.mutations(state)
mutations.reset = resetState

const _statusStore = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions: {
    async fetchByEntityType({state}, entityType) {
      if (checkLocalStorage(state, {enityType: camelize(entityType), module: Constants.LOCAL_STORAGE.LOCATION.STATUS_DATA}, Constants.LOCAL_STORAGE.EXPIRATION.ONE_MONTH)) {
        return
      }

      const response = await ptracGetEntities('statuses/search/findByEntityTypeOrderBySortAsc?entityType=' + entityType)
      if (OK === response.status) {
        state[camelize(entityType)] = kvps(response.data, 'name', 'name')
        setLocalStorage(camelize(entityType) + Constants.LOCAL_STORAGE.LOCATION.STATUS_DATA, state[camelize(entityType)])
      }
    }
  }
}

export {_statusStore}
export default _statusStore
